import {Component, TemplateRef} from '@angular/core';
import {ToastService} from "../../../Services/ToastService";

@Component({
  selector: 'app-app-loader',
  templateUrl: './app-loader.component.html',
  styleUrls: ['./app-loader.component.css']
})
export class AppLoaderComponent {
  constructor(public toastService: ToastService) {}

  ngOnInit(): void {}

  isLoading() {
    return this.toastService.display;
  }
}
